import * as Sentry from '@sentry/browser'
import { Integrations } from '@sentry/tracing'
import React from 'react'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
import ReactDOM from 'react-dom'
import App from './App'
import './App.css'
import 'ui/mcss-ui.css'
import * as serviceWorker from './serviceWorker'
import ReactGA from 'react-ga'
import { createRoot } from 'react-dom/client'

// Basic logging setup
console.log('index.tsx: Application initializing')

// Simple error handler for unhandled promise rejections
window.addEventListener('unhandledrejection', function (event) {
  console.error('Unhandled Promise Rejection:', event.reason)
})

const privateFieldNames = [
  'ssn',
  'firstName',
  'birthDate',
  'password',
  'Authorization',
]

ReactGA.initialize(import.meta.env.REACT_APP_GOOGLE_ANALYTICS ?? '')
// Sentry.init({
//   dsn: 'https://c2dbced6f8e845a2b4c870e63110a673@sentry.io/1872067',
//   environment: import.meta.env.REACT_APP_ENVIRONMENT || 'local',
//   integrations: [new Integrations.BrowserTracing()],
//   // We recommend adjusting this value in production, or using tracesSampler
//   // for finer control
//   tracesSampleRate: 1.0,
// })

// Simplified initialization
console.log('index.tsx: Setting up React application')
const container = document.getElementById('root')
const root = createRoot(container!) // createRoot(container!) if you use TypeScript
root.render(<App />)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
